<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      :mini-variant="miniDrawer"
      app
    >
      <v-list dense>
        <template v-for="item in mainMenuItems">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else
            :key="item.text"
            v-show="item.enabled"
            @click="mainMenu(item)"
          >
            <v-list-item-action>
              <div class="text-center d-flex align-center justify-space-around">
                <v-tooltip right open-delay="1000" :disabled="!miniDrawer">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">{{ item.icon }}</v-icon>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </div>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <div v-if="miniDrawer">
            <v-btn @click="miniDrawer = false" icon>
              <v-icon>mdi-unfold-more-vertical</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn @click="miniDrawer = true" block depressed>
              <v-icon>mdi-unfold-less-vertical</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="primary"
      app
      dense
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <v-toolbar-title style="width: 300px">
        <span><v-btn text @click="goHome()">Proteus</v-btn></span>
      </v-toolbar-title>

      <v-spacer />

      <v-btn
        icon
        @click="$vuetify.theme.dark = false"
        v-if="$vuetify.theme.dark"
      >
        <v-icon>mdi-weather-sunny</v-icon>
      </v-btn>
      <v-btn icon @click="$vuetify.theme.dark = true" v-else>
        <v-icon>mdi-weather-night</v-icon>
      </v-btn>

      <v-menu left bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <img v-if="avatar" height="40" class="img-circle" :src="avatar" />
            <avatar
              v-else
              :username="username"
              :size="40"
              :rounded="true"
              class="default-avatar"
              :lighten="90"
              color="#000"
              background-color="#EEF0EB"
            ></avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-for="item in userMenuItems"
            :key="item.id"
            @click="userMenu(item)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <component v-bind:is="content"></component>
    </v-main>

    <ErrorConsole v-if="console" v-bind:logger="logger"></ErrorConsole>

    <PermissionsChangeModal
      ref="permissionsChangeModal"
    ></PermissionsChangeModal>

    <InfoModal v-if="info" @onClose="info = false"></InfoModal>

    <!-- Alert Snackbars -->
    <v-snackbar
      v-model="snackbarShow"
      :timeout="snackbarTimeout"
      color="cyan darken-2"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarShow = false">{{
          $t("close")
        }}</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar top v-model="alertShow" :timeout="alertTimeout" color="error">
      {{ alertText }}
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="alertShow = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Worklist from "../components/Worklist.vue";
import Studies from "../components/Studies.vue";
import Configuration from "../components/Configuration.vue";
import Permissions from "../components/Permissions.vue";
import Auditory from "../components/Auditory.vue";
import Printer from "../components/Printer.vue";

import Account from "../components/Account.vue";

import ErrorConsole from "../components/Home/ErrorConsole.vue";
import PermissionsChangeModal from "../components/Home/PermissionChangedModal.vue";
import InfoModal from "../components/Home/InfoModal.vue";

import Avatar from "vue-avatar";
import EventBus from "../event-bus";
import i18n from "../i18n";

import { mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    Avatar,
    Worklist,
    Studies,
    Configuration,
    Permissions,
    Auditory,
    Printer,
    Account,
    PermissionsChangeModal,
    ErrorConsole,
    InfoModal,
  },
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    miniDrawer: true,
    userMenuItems: [],
    mainMenuItems: [],
    content: "Studies",
    alertText: null,
    alertShow: false,
    snackbarText: null,
    snackbarTimeout: null,
    snackbarShow: false,
    alertTimeout: 10000,
    username: "",
    console: false,
    info: false,
    enableStudies: false,
    enableWorklist: false,
    enableConfiguration: false,
    enablePermissions: false,
    enableAuditory: false,
    enablePrinter: false,
  }),
  computed: {
    ...mapGetters(["avatar", "logger"]),
  },
  mounted() {
    // Studies
    if (typeof this.$store.getters.resources.studies !== "undefined") {
      this.enableStudies = this.$store.getters.resources.studies.read;
    }

    // Worklist
    if (typeof this.$store.getters.resources.worklist !== "undefined") {
      this.enableWorklist = this.$store.getters.resources.worklist.read;
    }

    // Configuration
    if (typeof this.$store.getters.resources.configuration !== "undefined") {
      let configStore = this.$store.getters.resources.configuration;
      let config = ["worklist", "dicom", "main", "storage"];

      for (let i = 0; i < config.length; i++) {
        if (typeof configStore[config[i]] !== "undefined") {
          if (configStore[config[i]].read) {
            this.enableConfiguration = true;
          }
        }
      }
    }

    // Permissions
    if (typeof this.$store.getters.resources.permissions !== "undefined") {
      let permissionsStore = this.$store.getters.resources.permissions;
      let config = ["users", "tokens", "roles"];

      for (let i = 0; i < config.length; i++) {
        if (typeof permissionsStore[config[i]] !== "undefined") {
          if (permissionsStore[config[i]].read) {
            this.enablePermissions = true;
          }
        }
      }
    }

    // Auditory
    if (typeof this.$store.getters.resources.auditory !== "undefined") {
      this.enableAuditory = this.$store.getters.resources.auditory.read;
    }

    // Printer
    if (typeof this.$store.getters.resources.printer !== "undefined") {
      this.enablePrinter = this.$store.getters.resources.printer.read;
    }

    this.userMenuItems = [
      {
        id: "user-account",
        text: i18n.t("account"),
        icon: "mdi-account",
      },
      {
        id: "user-help",
        text: i18n.t("help"),
        icon: "mdi-help-circle",
      },
      {
        id: "user-info",
        text: i18n.t("info"),
        icon: "mdi-information",
      },
      {
        id: "user-logout",
        text: i18n.t("logout"),
        icon: "mdi-logout",
      },
    ];

    this.mainMenuItems = [
      {
        id: "main-studies",
        text: i18n.t("studies"),
        icon: "mdi-file-search",
        enabled: this.enableStudies,
      },
      {
        id: "main-worklist",
        text: i18n.t("worklist"),
        icon: "mdi-clipboard-text",
        enabled: this.enableWorklist,
      },
      {
        id: "main-configuration",
        text: i18n.t("configuration"),
        icon: "mdi-cog",
        enabled: this.enableConfiguration,
      },
      {
        id: "main-permissions",
        text: i18n.t("permissions"),
        icon: "mdi-shield-account",
        enabled: this.enablePermissions,
      },
      {
        id: "main-auditory",
        text: i18n.t("auditory"),
        icon: "mdi-history",
        enabled: this.enableAuditory,
      },
      {
        id: "main-printer",
        text: i18n.t("printer"),
        icon: "mdi-printer",
        enabled: this.enablePrinter,
      },
    ];

    this.username = this.$store.state.userSession.username;

    window.addEventListener("keydown", this.keydown);

    // Dark Mode
    if (this.$store.state.userSession.dark_mode == null) {
      if (
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      ) {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    } else {
      this.$vuetify.theme.dark = this.$store.state.userSession.dark_mode;
    }

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        if (this.$store.state.userSession.dark_mode == null) {
          if (e.matches) {
            this.$vuetify.theme.dark = true;
          } else {
            this.$vuetify.theme.dark = false;
          }
        }
      });
  },
  created() {
    // Set home locale.
    i18n.locale = localStorage.locale;

    // Show errors
    EventBus.$on(
      "SHOW_ERROR",
      function (message) {
        this.alertText = message;
        this.alertShow = !!message;
      }.bind(this)
    );

    EventBus.$on(
      "SHOW_SNACKBAR",
      function (message, timeout) {
        this.snackbarText = message;
        this.snackbarTimeout = timeout;
        this.snackbarShow = !!message;
      }.bind(this)
    );

    EventBus.$on(
      "SHOW_PERMISSION_CHANGE_MODAL",
      function () {
        this.$refs.permissionsChangeModal.show();
      }.bind(this)
    );

    // Set fast link page
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    let action = params.get("action");

    if (action === "search") {
      this.content = "Studies";
    }
  },
  methods: {
    goHome() {
      if (this.enableStudies) {
        this.content = "Studies";
      } else if (this.enableWorklist) {
        this.content = "Worklist";
      } else if (this.enableConfiguration) {
        this.content = "Configuration";
      } else if (this.enablePermissions) {
        this.content = "Permissions";
      } else if (this.enableAuditory) {
        this.content = "Auditory";
      } else if (this.enablePrinter) {
        this.content = "Printer";
      }
    },
    mainMenu(item) {
      // select content
      switch (item.id) {
        case "main-studies":
          this.content = "Studies";
          break;
        case "main-worklist":
          this.content = "Worklist";
          break;
        case "main-configuration":
          this.content = "Configuration";
          break;
        case "main-permissions":
          this.content = "Permissions";
          break;
        case "main-auditory":
          this.content = "Auditory";
          break;
        case "main-printer":
          this.content = "Printer";
          break;
      }

      // close drawer
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.drawer = false;
      }
    },
    userMenu(item) {
      switch (item.id) {
        case "user-account":
          this.content = "Account";
          break;
        case "user-help":
          window.open("https://www.idria.com.ar/proteus/docs/intro");
          break;
        case "user-info":
          this.info = true;
          break;

        // Logout user session.
        case "user-logout": {
          let self = this;
          this.$store
            .dispatch("logout")
            .then(() => self.$router.push("/login"))
            .catch((err) => console.log(err));
        }
      }
    },
    keydown(e) {
      if (e.ctrlKey && e.keyCode == 69) {
        this.console = !this.console;
        e.preventDefault();
      }
    },
  },
  destroyed() {
    window.removeEventListener("keydown", this.keydown);
  },
};
</script>

<style scoped>
.v-alert {
  margin-bottom: 0px !important;
}
.v-list {
  text-transform: capitalize;
}
.img-circle {
  border-radius: 50%;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.console::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.console {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>